module.exports = {
    asoleacionData: () => {
        return[
            {
                "asoleacion":[
                    {
                        "hours":[
                            {
                                "image":require("./../UI/icons/Asoleacion/Noche.svg"),
                                "second":"8"
                            },
                            {
                                "image":require("./../UI/icons/Asoleacion/Atardecer.svg"),
                                "second":"5.8"
                            },
                            {
                                "image":require("./../UI/icons/Asoleacion/Mediodia.svg"),
                                "second":"3"
                            },
                            {
                                "image":require("./../UI/icons/Asoleacion/Amanecer.svg"),
                                "second":"0"
                            },
                        ],
                        "initialTime":"1.2",
                        "vistas":{
                            "V1": {
                                "video":require("./../UI/Video/Asoleacion01.mp4"),
                                "reversed":require("./../UI/Video/Asoleacion01-Reverse.mp4"),
                                "angle":"80"
                            },
                            "V2": {
                                "video":require("./../UI/Video/Asoleacion02.mp4"),
                                "reversed":require("./../UI/Video/Asoleacion02-Reverse.mp4"),
                                "angle":"40"
                            },
                            "V3": {
                                "video":require("./../UI/Video/Asoleacion03.mp4"),
                                "reversed":require("./../UI/Video/Asoleacion03-Reverse.mp4"),
                                "angle":"114"
                            }
                        }
                    }
                ]
            }
        ]
    }
}